module.exports = __webpack_public_path__ + "res/logo_white.925df9603d55f8ff12d2fed2485dd7ee.png";